import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Portal from "../../../Hooks/Portal";


const Modal = ({children, toggle, open}) => (
    <div>
        {open ? (
            <Portal>
                <ModalWrapper>
                    <ModalCard>
                        {children}
                    </ModalCard>
                    <Background onClick={toggle}/>
                </ModalWrapper>
            </Portal>
        ) : ""}
    </div>
);

export default Modal;

const ModalWrapper = styled.div`
  position: fixed;  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const ModalCard = styled.div`
  position: relative;
  z-index: 10;
`;

const Background = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: black;
  opacity: 0.6;
`;